import { Component, OnInit, DoCheck, ChangeDetectorRef, DOCUMENT } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { CalculationService } from "./services/calculation.service";

import { PageScrollService } from 'ngx-page-scroll-core';
import { PageScrollInstance } from 'ngx-page-scroll-core';
import { Inject } from '@angular/core';
import { FormDataService } from './services/form-data.service';
import { CurrencyService } from './services/currency.service';
import { BehaviorSubject, finalize } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
  providers: [FormBuilder],
})
export class AppComponent implements OnInit, DoCheck{
  public handledDataJSON: any = {};
  public handledJSONWithPrem: any = {};
  public  manPrem: any;
  private currency: string;
  private amoutOfMoney: number;
  private selectedPaymentType: number;
  public isHeaderButtonClicked: boolean = false;
  private isFinancialProtectionClicked: boolean = false;
  private isProtectionClicked: boolean = false;
  private isChoiceClicked: boolean = false;
  private isSecondMedicalOptionClicked: boolean = false;
  private isAllOverTheWorldCoverClicked: boolean = false;
  private resArray: any = [];
  public showDialog: boolean;
  public isVisible: boolean = false;
  public cleanInputForm: boolean;
  public returnedData: any = [];
  public state: boolean = false;
  public removePackages: boolean = false;
  public hide: boolean;

  public initManPrem: number;

  public isSendButtonClicked: boolean = false;
  public isEmailSent: boolean = false;

  public isCrillAndSecMedOPChecked1: boolean = false;
  public isCrillAndSecMedOPChecked2: boolean = false;
  public isCrillAndSecMedOPChecked3: boolean = false;

  public isForPrint: boolean;

  public isPrintChosen: boolean = false;
  public isEmailChosen: boolean = false;

  // variables that show or hide some error message on the screen
  public isThereEmptyField: boolean = false;
  public areAllInputFieldsCorrect: boolean = true;

  public isThereEmptyFieldPrint: boolean = false;
  public areAllInputFieldsCorrectPrint: boolean = true;

  public isPDFGenerated = true;

  public doShowPackages = false;
  public loading$ = new BehaviorSubject<boolean>(false)

  // Modal form's inputs real time validations
  userFormGroup = new FormGroup({
    username: new FormControl(null, Validators.compose([Validators.pattern(new RegExp(/^[a-zA-Zа-яА-Я\.\-\' ]+$/)), Validators.required])),
    email: new FormControl(null, Validators.compose([Validators.pattern(new RegExp(/^[a-zA-Z0-9.!#$%’'/*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/)), Validators.required])),
  });

  constructor(public formBuilder: FormBuilder, private calculationService: CalculationService, 
    private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: Document,
    public currencyService: CurrencyService,
    private data: FormDataService) { }

  ngOnInit(){
    this.loading$.next(true);
    this.data.currentState.subscribe(state => this.state = state);
    this.currencyService.getCurrencyConfig().subscribe((res: any) => {
      this.currencyService.currencyConfig$.next(res.main);
      this.loading$.next(false)
    })
  }

  ngDoCheck(){
    if(!this.showDialog){
      this.isEmailSent = false;
      this.isSendButtonClicked = false;
    }
  }

  // function, which handles the data comming from the other component (main-input-form)
  onChangedData(newDataJSON: any) {
    this.manPrem = false;
    this.handledJSONWithPrem = [];
    this.handledDataJSON = newDataJSON;
    this.amoutOfMoney = this.handledDataJSON.amoutOfMoney;
  }

  initManPremHandler(initManPrem: number){
    this.initManPrem = initManPrem;
  }

  hidePackages(yearsOfDuration65) {
    this.hide = yearsOfDuration65;
    if (yearsOfDuration65) {
      this.manPrem = false;
      this.handledJSONWithPrem = [];
    }
  }
  showPackages(isEverythingCorrect: any) {
    this.doShowPackages = isEverythingCorrect;
    if (!isEverythingCorrect) {
      this.manPrem = false;
      this.handledJSONWithPrem = [];
    }
  }

  // function, which handles the data comming from the others components (protect-light, protect-plus, protect-premium, protect-custom)
  onChangedPrem(newJSONWithPrem: any) {
    this.manPrem = newJSONWithPrem.manPrem;
    this.handledJSONWithPrem = newJSONWithPrem;

    this.currency = this.handledDataJSON.currency;
    this.selectedPaymentType = this.handledDataJSON.selectedPaymentType;

    setTimeout(() => {
      const pageScrollInstance: PageScrollInstance = this.pageScrollService.create({
        document: this.document,
        scrollTarget: '#result'
      });
    
      this.pageScrollService.start(pageScrollInstance);
    }, 0);

  }

  lightCheck(lightCheck1: boolean){
    this.isCrillAndSecMedOPChecked1 = lightCheck1;
    this.isCrillAndSecMedOPChecked2 = false;
    this.isCrillAndSecMedOPChecked3 = false;
  }
  plusCheck(plusCheck1: boolean){
    this.isCrillAndSecMedOPChecked1 = false;
    this.isCrillAndSecMedOPChecked2 = plusCheck1;
    this.isCrillAndSecMedOPChecked3 = false;
  }
  protectCheck(protectCheck1: boolean){
    this.isCrillAndSecMedOPChecked1 = false;
    this.isCrillAndSecMedOPChecked2 = false;
    this.isCrillAndSecMedOPChecked3 = protectCheck1;
  }

  // function, which will be activated when the header button is clicked
  expandTheHeader() {
    this.isHeaderButtonClicked = !this.isHeaderButtonClicked;
  }

  // function, which will be activated when the some of the buttons inside the expanded header part is clicked (бутонът финансова сигурност)
  expandFinancialProtection() {
    this.isFinancialProtectionClicked = !this.isFinancialProtectionClicked;
  }

  // function, which will be activated when the some of the buttons inside the expanded header part is clicked (бутонът защита)
  expandProtection() {
    this.isProtectionClicked = !this.isProtectionClicked;
  }

  // function, which will be activated when the some of the buttons inside the expanded header part is clicked (бутонът избор)
  expandChoice() {
    this.isChoiceClicked = !this.isChoiceClicked;
  }

  // function, which will be activated when the some of the buttons inside the expanded header part is clicked (бутонът второ лекарско мнение)
  expandSecondMedicalOption() {
    this.isSecondMedicalOptionClicked = !this.isSecondMedicalOptionClicked;
  }

  // function, which will be activated when the some of the buttons inside the expanded header part is clicked (бутонът покритие: цял свят)
  expandAllOverTheWorldCover() {
    this.isAllOverTheWorldCoverClicked = !this.isAllOverTheWorldCoverClicked;
  }

  // sneding an email to the user with attached pdf
  sendOrPrint(isForEmail: boolean = true, isForPrint: boolean = false) {

    if( isForPrint ){
      if (!this.userFormGroup.controls['username'].value) {
        this.isThereEmptyFieldPrint = true;
      } else {
        this.isThereEmptyFieldPrint = false;
        if (new RegExp(/^[a-zA-Zа-яА-Я\.\-\' ]+$/).test(this.userFormGroup.controls['username'].value)) {
          this.areAllInputFieldsCorrectPrint = true;

          this.callPrintEmailService( isForEmail, isForPrint );

        } else {
          this.areAllInputFieldsCorrectPrint = false;
        }
      }
    } else {

      this.isSendButtonClicked = true;

      // Validation - check if all mоdal forms's inputs are correct
      this.isThereEmptyField = false;
      this.areAllInputFieldsCorrect = true;

      if (!this.userFormGroup.controls['username'].value || !this.userFormGroup.controls['email'].value) {
        this.isThereEmptyField = true;
      }
      else {
        this.isThereEmptyField = false;

        if (new RegExp(/^[a-zA-Zа-яА-Я\.\-\' ]+$/).test(this.userFormGroup.controls['username'].value)) {
          this.areAllInputFieldsCorrect = true;

          if (new RegExp(/^[a-zA-Z0-9.!#$%’'/*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/).test(this.userFormGroup.controls['email'].value)) {
            this.areAllInputFieldsCorrect = true;

            this.callPrintEmailService( isForEmail, isForPrint );
            
          }
          else {
            this.areAllInputFieldsCorrect = false;
          }
        }
        else {
          this.areAllInputFieldsCorrect = false;
        }
      }

    }
    
  }

  callPrintEmailService(isForEmail: boolean = true, isForPrint: boolean = false){

    const name = this.userFormGroup.controls['username'].value ? this.userFormGroup.controls['username'].value : null;
    const mail = this.userFormGroup.controls['email'].value ? this.userFormGroup.controls['email'].value : null;
    this.loading$.next(true);

    this.resArray = []; // Clear previous response

  this.calculationService.sendDataForPDF(
    this.handledJSONWithPrem.customPackage,
    this.handledJSONWithPrem.crill,
    this.handledJSONWithPrem.secondMedOp,
    this.handledDataJSON.bornDate,
    this.handledDataJSON.years,
    this.handledDataJSON.amoutOfMoney,
    this.handledDataJSON.currency,
    this.handledDataJSON.selectedPaymentType,
    this.handledJSONWithPrem.death,
    this.handledJSONWithPrem.stayAtHospital,
    this.handledJSONWithPrem.expenditureForMedicines,
    this.handledJSONWithPrem.temporraryLossOfEmployment,
    this.handledJSONWithPrem.longTermLossOfEmployment,
    this.handledJSONWithPrem.manPrem,
    name,
    mail,
    isForEmail,
    isForPrint
  )
  .pipe(
    finalize(() => this.loading$.next(false)) 
  )
  .subscribe({
    next: (res:any) => {
      this.resArray.push(res);

      if (isForPrint) {
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
                          'resizable,screenX=50,screenY=50,width=850,height=1050';
        const navigatorAny: any = window.navigator;
        const file = new Blob([res.body], { type: 'application/pdf' });

        if (navigatorAny && navigatorAny.msSaveOrOpenBlob) {
          navigatorAny.msSaveOrOpenBlob(file, "Individual_Offer_" + this.getCurrentTime() + ".pdf");
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, "PDF", winparams);
        }

        this.isPDFGenerated = true;
      }

      if (isForEmail) {
        this.isEmailSent = true;
        this.isPDFGenerated = true;
      }
    },
    error: () => {
      this.isPDFGenerated = false;
    }
  });

    this.resArray = [];
  }

  getProtectCustomData(returnedData: any = []){
    this.returnedData=returnedData;
  }

  exportFromPayment($event){
    this.data.changeState(true);
    this.doShowPackages = false;
    this.returnedData = [];
    this.manPrem = false;
    this.handledJSONWithPrem=[];
  }

  removePackage($event){
    this.returnedData = [];
    this.manPrem = false;
    this.handledJSONWithPrem=[];
  }

  getCurrentTime(){
    let currentTime = new Date();
    let month = currentTime.getMonth() + 1;
    let day = currentTime.getDate();
    let currentTimeString = currentTime.getFullYear() + '-';
    currentTimeString +=  month.toString().length == 1 ? '0' + month + '-' : month + '-';
    currentTimeString += day.toString().length == 1 ? '0' + day + '-' : day + '_';
    currentTimeString += currentTime.getTime();

    return currentTimeString;
  }

}
